<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="1100px">
    <v-card class="sellers-actions-container">
      <v-card-title class="d-flex justify-content-between h-75px">
        <div>
          <span class="font-weight-medium m-4 text-h5">Bulk Edit</span>
        </div>
        <button @click="toggleModal">
          <span class="svg-icon me-2">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </button>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-card class="p-5 sellers-tab-card">
            <!--              <v-card flat class="d-flex flex-column">-->
            <div class="mt-6 d-flex flex-column flex-fill custom-tab-container">
              <v-container class="d-flex flex-column flex-fill ms-2 me-4">
                <v-row v-if="serverData">
                  <v-col cols="12" lg="8">
                    <FieldContainer label="SKU type">
                      <v-autocomplete
                        v-model="formData.sku_type_id"
                        class="rounded-lg h-45px"
                        :items="serverData.sku_types"
                        item-text="text"
                        item-value="index"
                        clearable
                        outlined
                        dense
                        hide-details
                      />
                    </FieldContainer>

                    <FieldContainer label="Category">
                      <v-autocomplete
                        v-model="formData.categories"
                        class="rounded-lg h-45px"
                        :items="serverData.groups"
                        item-text="text"
                        item-value="index"
                        clearable
                        outlined
                        dense
                        hide-details
                        multiple
                        deletable-chips
                      />
                    </FieldContainer>

                    <FieldContainer label="Country">
                      <v-autocomplete
                        v-model="formData.country_id"
                        class="rounded-lg h-45px"
                        :items="serverData.countries"
                        item-text="text"
                        item-value="index"
                        clearable
                        outlined
                        dense
                        hide-details
                      />
                    </FieldContainer>

                    <FieldContainer label="Currency">
                      <v-autocomplete
                        v-model="formData.currency_id"
                        class="rounded-lg h-45px"
                        :items="serverData.currencies"
                        item-text="text"
                        item-value="index"
                        clearable
                        outlined
                        dense
                        hide-details
                      />
                    </FieldContainer>

                    <FieldContainer label="Expire control">
                      <v-autocomplete
                        v-model="formData.expiry_control"
                        class="rounded-lg h-45px"
                        :items="serverData.expiry_controls"
                        item-text="text"
                        item-value="index"
                        clearable
                        outlined
                        dense
                        hide-details
                      />
                    </FieldContainer>

                    <FieldContainer label="Serial number control">
                      <v-autocomplete
                        v-model="formData.serial_number_control"
                        class="rounded-lg h-45px"
                        :items="serverData.serial_number_controls"
                        item-text="text"
                        item-value="index"
                        clearable
                        outlined
                        dense
                        hide-details
                      />
                    </FieldContainer>

                    <FieldContainer label="HS code">
                      <v-text-field
                        v-model="formData.hs_code"
                        class="rounded-lg h-45px"
                        clearable
                        outlined
                        dense
                        hide-details
                      />
                    </FieldContainer>

                    <FieldContainer
                      label="Out of stock threshold"
                      :divider="false"
                    >
                      <v-text-field
                        v-model.number="formData.out_of_stock_threshold"
                        class="rounded-lg h-45px"
                        clearable
                        outlined
                        dense
                        hide-details
                        type="number"
                        :min="0"
                        @blur="() => validateMinValue('out_of_stock_threshold')"
                      />
                    </FieldContainer>
                  </v-col>
                </v-row>

                <v-row class="mt-6">
                  <v-col cols="12" lg="8" class="pe-0">
                    <v-row class="d-flex justify-content-end">
                      <v-col cols="auto">
                        <button
                          @click="submit"
                          type="submit"
                          class="btn btn-info px-5 py-3"
                        >
                          Submit
                          <!--                          {{ this.$t("submit") }}-->
                        </button>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </div>
            <!--              </v-card>-->
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import FieldContainer from "@/own/components/fulfillment/skus/FieldContainer.vue";
import fieldValueValidation from "@/own/mixins/fieldValueValidation";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import Swal from "sweetalert2";

export default {
  name: "BulkEditFormFields",
  mixins: [fieldValueValidation],
  components: { FieldContainer },
  props: ["refresher", "ids"],
  data: () => ({
    formData: {
      sku_type_id: null,
      categories: [],
      currency_id: null,
      country_id: null,
      expiry_control: null,
      serial_number_control: null,
      hs_code: null,
      out_of_stock_threshold: null,
    },
    serverData: null,
    dialog: false,
  }),
  methods: {
    loadServerData() {
      this.$store.commit(SET_PAGE_LOADING, true);

      ApiService.post("/fulfillment/skus/bulk_edit", { ids: this.ids })
        .then(({ data }) => {
          this.serverData = data;
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    submit() {
      this.$store.commit(SET_PAGE_LOADING, true);

      ApiService.post("/fulfillment/skus/bulk_update", {
        ids: this.ids,
        ...this.formData,
      })
        .then(({ data }) => {
          if (data.success) {
            Swal.fire({
              title: "Success",
              text: "Record has been updated successfully",
              icon: "success",
              showConfirmButton: true,
            });
            this.refresher();
            this.toggleModal();
          } else {
            Swal.fire({
              title: "Warning",
              text: data.message ?? "Something went wrong",
              icon: "warning",
              showConfirmButton: false,
              showCancelButton: true,
              cancelButtonText: "OK",
              cancelButtonColor: "#FFA800",
            });
          }
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    reset() {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = null;
      });
    },
    toggleModal() {
      if (!this.dialog) this.loadServerData();
      else this.reset();
      this.dialog = !this.dialog;
    },
  },
  // computed: {},
};
</script>

<style lang="scss">
.sellers-tab-card {
  border: 1px solid #f1f1f4 !important;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03) !important;
}

.no-scrollbar {
  scrollbar-width: none;
}

.sellers-actions-container {
  .v-card__text {
    overflow: hidden !important;
  }
}

.custom-tab-container {
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100vh - 300px) !important;
}
</style>
